import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-product gfu-product--modal"
}
const _hoisted_2 = { class: "gfu-product__row" }
const _hoisted_3 = { class: "gfu-product__gallery gfu-1of1 gfu-1of2--m" }
const _hoisted_4 = { class: "gfu-embed gfu-embed--1x1" }
const _hoisted_5 = { class: "gfu-product__info gfu-1of1 gfu-1of2--m" }
const _hoisted_6 = { class: "gfu-product-content" }
const _hoisted_7 = { class: "gfu-product-status gfu-media gfu-media--middle _mb-3" }
const _hoisted_8 = { class: "gfu-media__body" }
const _hoisted_9 = { class: "gfu-hd gfu-hd--h4 gfu-hd--light" }
const _hoisted_10 = {
  class: "gfu-hd gfu-hd--d1 _mb-3 gfu-hd--decorative",
  "data-qa": "stretch-goal-name"
}
const _hoisted_11 = {
  class: "_mb-3",
  "data-qa": "stretch-goal-abstract"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "gfu-product-content _mt-6"
}
const _hoisted_14 = { class: "gfu-hd gfu-hd--h2 _tc--base _mb-2" }
const _hoisted_15 = {
  key: 1,
  class: "gfu-product__row gfu-product-content _mt-4"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_display_currency_value = _resolveComponent("display-currency-value")
  const _component_progress_bar = _resolveComponent("progress-bar")
  const _component_content_renderer = _resolveComponent("content-renderer")
  const _component_router_link = _resolveComponent("router-link")

  return ($options.model)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_themed_image, {
                class: "gfu-embed__item",
                src: $options.model.imageUrl,
                alt: $options.model.name,
                loading: "lazy"
              }, null, 8 /* PROPS */, ["src", "alt"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(['gfu-project-stretch-goal-icon _mr-1',
                                      {'gfu-project-stretch-goal-icon--success':  $options.model.isUnlocked }])
                }, [
                  _createVNode(_component_base_icon, {
                    name: $options.model.isUnlocked ? 'check' : 'lock'
                  }, null, 8 /* PROPS */, ["name"])
                ], 2 /* CLASS */),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h4", _hoisted_9, [
                    ($options.isBackedFunds)
                      ? (_openBlock(), _createBlock(_component_display_currency_value, { key: 0 }, {
                          "tooltip-content": _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.Resources.format(_ctx.Resources.ProjectHome.ProjectApproximateCurrencyConversionTooltip, _ctx.$format($options.model.targetValue, 'C0'))), 1 /* TEXT */)
                          ]),
                          content: _withCtx(({ displayCurrency }) => [
                            _createTextVNode(_toDisplayString($setup.resolveStatusText($options.model, displayCurrency.symbol, displayCurrency.relativeFactor)), 1 /* TEXT */)
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.resolveStatusText($options.model, $options.currencySymbol)), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString($setup.resolveStatusText($options.model)), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                  ]),
                  (!$options.model.isUnlocked && $options.model.isAutomatic)
                    ? (_openBlock(), _createBlock(_component_progress_bar, {
                        key: 0,
                        value: $options.model.value,
                        max: $options.model.targetValue,
                        class: "_mt-1",
                        "progression-class": "gfu-progress-bar__progression--accent"
                      }, null, 8 /* PROPS */, ["value", "max"]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("h1", _hoisted_10, _toDisplayString($options.model.name), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_11, _toDisplayString($options.model.abstract), 1 /* TEXT */),
              _createElementVNode("div", {
                innerHTML: $setup.resolveDescription($options.model, $options.currencySymbol, $options.currencyFactor) 
              }, null, 8 /* PROPS */, _hoisted_12)
            ])
          ])
        ]),
        ($options.model.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createCommentVNode(" <h2 class=\"gfu-hd gfu-hd--h2 _tc--base _mb-2\">More info</h2> "),
              _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.Resources.Common.MoreInfoHeader), 1 /* TEXT */),
              _createVNode(_component_content_renderer, {
                content: $options.model.description
              }, null, 8 /* PROPS */, ["content"])
            ]))
          : _createCommentVNode("v-if", true),
        ($options.next || $options.prev)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              ($options.prev)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: $options.prev,
                    class: "_tc--accent _flexaicntr",
                    rel: "prev"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_base_icon, {
                        name: "angle-left",
                        class: "_fl _mr-1 gfu-icon gfu-icon--big"
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryStretchGoalPreviousLink), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["to"]))
                : _createCommentVNode("v-if", true),
              ($options.next)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: $options.next,
                    class: "_tc--accent _flexaicntr _ml-a",
                    rel: "next"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryStretchGoalNextLink), 1 /* TEXT */),
                      _createVNode(_component_base_icon, {
                        name: "angle-right",
                        class: "_fr _ml-1 gfu-icon gfu-icon--big"
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["to"]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}